import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

export default function ProductDropdown() {
    const [openMain, setOpenMain] = useState(false);
    const [subMenu, setSubMenu] = useState(null);
    const timeoutRef = useRef(null);

    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileSub, setMobileSub] = useState(null);

    const handleMouseEnter = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setOpenMain(true);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setOpenMain(false);
            setSubMenu(null);
        }, 300); // 300ms delay to allow moving between menus
    };

    const handleSubMouseEnter = (item) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setSubMenu(item);
    };

    // Cleanup timer on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    const menu = {
        LOANS: [
            "HOME LOAN",
            "VEHICLE LOAN",
            "CASH CREDIT LOAN",
            "PERSONAL LOAN",
            "ECCS LOAN",
            "SHG LOAN",
            "KCC LOAN",
            "WORK ORDER LOAN",
            "TERM LOAN",
            "LOAN AGAINST NSC/ KVP/ LIC",
            "LOAN AGAINST DEPOSIT",
        ],
        DEPOSIT: [
            "SAVINGS ACCOUNT",
            "CURRENT ACCOUNT",
            "FIXED DEPOSIT",
            "CASH CERTIFICATE",
            "RECURRING DEPOSIT",
            "MIS",
        ],
        CARD: ["RuPay DEBIT Cum ATM", "KISHAN CREDIT CARD"],
    };

    return (
        <>
            {/* ================== DESKTOP ================== */}
            <div
                className="relative hidden md:block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <button className="px-4 py-3 font-semibold text-white hover:text-black transition">
                    PRODUCT ▾
                </button>

                {/* Main Dropdown Container - No vertical gap from button */}
                {openMain && (
                    <div className="absolute left-0 top-full pt-1 bg-transparent z-50">
                        {/* The actual menu with content */}
                        <div className="bg-blue-900 text-white w-48 shadow-xl rounded-sm border border-blue-800">
                            {Object.keys(menu).map((item) => (
                                <div
                                    key={item}
                                    onMouseEnter={() => handleSubMouseEnter(item)}
                                    className="px-4 py-3 border-b border-blue-700 hover:bg-blue-800 cursor-pointer flex justify-between items-center group transition-colors"
                                >
                                    <span>{item}</span>
                                    <span className="text-gray-400 group-hover:text-white transition-colors">›</span>
                                </div>
                            ))}
                        </div>

                        {/* Sub Dropdown anchored to the main menu */}
                        {subMenu && (
                            <div 
                                className="absolute left-full top-0 ml-[-1px] pl-1 bg-transparent h-full"
                                onMouseEnter={handleMouseEnter} // Keep open when entering sub-menu
                            >
                                <div className="bg-blue-800 text-white w-64 shadow-2xl rounded-sm p-2 border border-blue-700">
                                    {menu[subMenu].map((item) => (
                                        <Link
                                            key={item}
                                            className="block px-4 py-2 hover:bg-blue-700 rounded-sm transition-colors text-sm"
                                            to={"/" + item.toLowerCase().replace(/\s+/g, "_")}
                                            onClick={() => {
                                                setOpenMain(false);
                                                setSubMenu(null);
                                            }}
                                        >
                                            {item}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* ================== MOBILE ================== */}
            <div className="md:hidden">
                <button
                    onClick={() => setMobileOpen(!mobileOpen)}
                    className="w-full flex justify-between items-center px-4 py-3 font-semibold text-white bg-blue-600"
                >
                    PRODUCT
                    <span>{mobileOpen ? "▲" : "▼"}</span>
                </button>

                {/* Mobile Main List */}
                {mobileOpen && (
                    <div className="bg-blue-800 text-white px-4 py-2">
                        {Object.keys(menu).map((item) => (
                            <div key={item} className="mb-2">
                                {/* Section Button */}
                                <button
                                    onClick={() =>
                                        setMobileSub(mobileSub === item ? null : item)
                                    }
                                    className="w-full flex justify-between items-center py-2 font-semibold hover:text-gray-200"
                                >
                                    {item}
                                    <span>{mobileSub === item ? "▲" : "▼"}</span>
                                </button>

                                {/* Sub Items */}
                                {mobileSub === item && (
                                    <div className="pl-4">
                                        {menu[item].map((sub) => (
                                            <Link
                                                key={sub}
                                                className="block py-2 text-sm hover:text-gray-300"
                                                to={"/" + sub.toLowerCase().replace(/\s+/g, "_")}
                                            >
                                                {sub}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}
